module.exports = __webpack_public_path__ + "static/media/login.466e75ff.png";